import { useState } from 'react';
import '../styles/messenger-button.css';
import { OpenIcon } from './messenger/OpenIcon';
import { CloseIcon } from './messenger/CloseIcon';
import { WhatsAppIcon } from './messenger/WhatsAppIcon';
import { TelegramIcon } from './messenger/TelegramIcon';
import { ViberIcon } from './messenger/ViberIcon';
import { InstagramIcon } from './messenger/InstagramIcon';

const MessengerButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`mb mb_animate ${isOpen ? 'mb_open' : ''}`}>
      <div className='mb-btn'>
        <input
          type='checkbox'
          id='mb-btn-input-dropdown'
          className='mb-btn-input'
          checked={isOpen}
          onChange={toggleMenu}
        />
        <label htmlFor='mb-btn-input-dropdown' className='mb-btn-label'>
          <OpenIcon />
          <CloseIcon />
        </label>

        <WhatsAppIcon />
        <TelegramIcon />
        <ViberIcon />
        <InstagramIcon />
      </div>
    </div>
  );
};

export default MessengerButton;
